import * as Sentry from "@sentry/browser";

Sentry.init({
    dsn: 'https://0520d7a61689d2ee0d635aeedec9805c@sentry.citylink.pro/3',
    environment: env,
    attachStacktrace: true,
    enableTracing: true,
    ignoreErrors: [
        "ResizeObserver loop limit exceeded", // безобидная ошибка. ResizeObserver напрямую не используем, приходит откуда-то из стороннего кода
        "The operation is insecure", // возникает из-за отключённых у пользователя куки/локал_сторадж/сейшн_сторадж
        "Failed to read the 'sessionStorage' property", // возникает из-за отключённых у пользователя куки/локал_сторадж/сейшн_сторадж
        "Cannot read properties of null (reading 'setItem')", // возникает из-за отключённых у пользователя куки/локал_сторадж/сейшн_сторадж
        // Random plugins/extensions
        "top.GLOBALS",
        // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
        "originalCreateNotification",
        "canvas.contentDocument",
        "MyApp_RemoveAllHighlights",
        "http://tt.epicplay.com",
        "Can't find variable: ZiteReader",
        "jigsaw is not defined",
        "ComboSearch is not defined",
        "http://loading.retry.widdit.com/",
        "atomicFindClose",
        // Facebook borked
        "fb_xd_fragment",
        // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to
        // reduce this. (thanks @acdha)
        // See http://stackoverflow.com/questions/4113268
        "bmi_SafeAddOnload",
        "EBCallBackMessageReceived",
        // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
        "conduitPage",
    ],
    denyUrls: [
        // Facebook flakiness
        /graph\.facebook\.com/i,
        // Facebook blocked
        /connect\.facebook\.net\/en_US\/all\.js/i,
        // Woopra flakiness
        /eatdifferent\.com\.woopra-ns\.com/i,
        /static\.woopra\.com\/js\/woopra\.js/i,
        // Chrome extensions
        /extensions\//i,
        /^chrome:\/\//i,
        /^chrome-extension:\/\//i,
        // Other plugins
        /127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
        /webappstoolbarba\.texthelp\.com\//i,
        /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
    ],
    integrations: [
        Sentry.browserTracingIntegration(),
    ],
    tracePropagationTargets: ['localhost', /^\//],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
});

